
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';

@Component({ components: { Popup } })
export default class ConfirmCancellationPopup extends Vue {
  @Emit()
  confirm() {}
  @Emit()
  close() {}
  onConfirm(): void {
    this.confirm();
  }
  hidePopup(): void {
    this.close();
  }
}
